export var getUTCTime = function getUTCTime(datetime) {
  return datetime.toUTCString();
};
export var getUnixTime = function getUnixTime(datetime) {
  return datetime.getTime() / 1000;
};